/**
 * Ajax filtering for the search and filter module
 */
(function (window, document, $, undefined) {
	'use strict';

	window.searchFilter = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			searchFilter.initVars();
			searchFilter.getQueryVars();
			searchFilter.pageInit();
			searchFilter.bind();
			searchFilter.submit();
			searchFilter.filterToggle();
			searchFilter.filterReset();
		},

		/**
		 * Setting and initializing all variables.
		 *
		 * @since 1.0.0
		 */
		initVars: function () {
			searchFilter.$base_url   = $(".page-template-our-people #base_url").val();
			searchFilter.$xhrQueue   = [];
			searchFilter.$form_reset = false;
			searchFilter.$form_name  = $( "#people-search-filter" ).data( 'form-name' );
			searchFilter.$resetStat  = false;
		},

		/**
		 * Get all of the select values for the query string
		 *
		 * @since 1.0.0
		 */
		getQueryVars: function () {
			// (re)set the object
			searchFilter.$query_vars = {};

			// Get non-checkbox values
			$('.filter-select').each(
				function () {
					// If a form field ins't empty add it to the array
					if ($(this).val() !== '') {
						searchFilter.$query_vars[$(this).data('arg-type')] = $(this).val();
					}
				}
			);

			// Special handling for tags checkboxes
			// Grab all the values and comma separate them
			searchFilter.$tagValues = $('.page-template-our-people .tag-checkbox:checked').map(
				function () {
					return $(this).val();
				}
			).get().join(",");

			if (searchFilter.$tagValues != '') {
				searchFilter.$query_vars['tags'] = searchFilter.$tagValues;
			}
		},

		/**
		 * Build the URL we need to call
		 *
		 * @since 1.0.0
		 */
		buildTheURL: function () {
			// Build the query string
			searchFilter.getQueryVars();

			// If empty use the base URL
			if ($.isEmptyObject(searchFilter.$query_vars)) {
				return searchFilter.$base_url;
			}

			var query_vars = '?';
			Object.keys( searchFilter.$query_vars ).forEach(
				function (key) {
					var value = searchFilter.$query_vars[key];
					query_vars += key + '=' + value.replace(/\s/g, "+") + '&';
				}
			);
			return searchFilter.$base_url + query_vars.replace( /&\s*$/, "" );
		},

		/**
		 * Put everything together and make the call
		 *
		 * @since 1.0.0
		 */
		makeTheCall: function ( url, reset_stat ) {
			searchFilter.$resetStat = reset_stat || false;
			// Kill all active xhr requests before starting a new one.
			var i = 0;
			while (searchFilter.xhrAbort() && i < searchFilter.$xhrQueue.length) {
				searchFilter.$xhrQueue[i].abort();
				i++;
			}

			// Make the call
			searchFilter.filterAjaxCall( url, searchFilter.$resetStat );
		},

		/**
		 * Call the formatted URL
		 *
		 * @since 1.0.0
		 */
		filterAjaxCall: function ( url, reset_stat ) {
			searchFilter.$resetStat = reset_stat || false;
			// Show the 'loading' overlay
			$('.page-template-our-people .loading-overlay').show();

			// Make the call
			$(".page-template-our-people #ajax-archive").load(
				url + ' #ajax-archive', function (response, status, xhr) {
					err = '';
					if (status == "success") {
						// Hide the overlay on success
						$('.loading-overlay').hide();
						// Push the browser history state
						var stateObj = { state: "ready" };
						var page_title = $(document).find("title").text();
						history.pushState(stateObj, page_title, url);
					} else {
						if( typeof xhr.responseText != 'undefined' ){
							var err = JSON.parse( xhr.responseText );
						}
					}

					// Check if form was reset
					if( insightsFilter.$resetStat == false ) {
						gtmHelper.formSubmitEvent( searchFilter.$form_name, status, err );					
					}
				}
			);
		},

		/**
		 * Abort all active xhr requests before making a new one.
		 *
		 * @since 1.0.0
		 */
		xhrAbort: function () {
			$(document).ajaxSend(
				function (event, jqxhr, settings) {
					searchFilter.$xhrQueue.push(jqxhr); //alert( settings.url );
				}
			);
			$(document).ajaxComplete(
				function (event, jqxhr, settings) {
					var i;
					if ((i = $.inArray(jqxhr, searchFilter.$xhrQueue)) > -1) {
						searchFilter.$xhrQueue.splice(i, 1); //alert( "C:" + settings.url );
					}
				}
			);
			return searchFilter.$xhrQueue.length;
		},
		
				/**
		 * Toggle the tag selector div
		 *
		 * @since 1.0.0
		 */
		filterToggle: function() {
			$( ".page-template-our-people #filter-toggle" ).click(
				function(e) {
					e.preventDefault();
					$( "#people-search-filter" ).toggle(
						500, function() {
						}
					);
					if($(this).html() == 'Filter By')
					{
						$(this).html('Close <i class="fa fa-times"></i>');
					}
					else
					{
						$(this).html('Filter By');
					}
				}
			);
		},

		/**
		 * Reset the filter
		 *
		 * @since 1.0.0
		 */
		filterReset: function() {
			$( ".page-template-our-people #filter-reset" ).click(
				function(e) {
					e.preventDefault();
					
					if( encodeURI(window.location.href) !== searchFilter.$base_url ) {
						// Reset the filter form to empty
						$( '.search-filter' ).trigger( "reset" );

						// Manually set the select2.js fields to empty and reset them
						//$( '.filter-select' ).val( [''] );
						//$( '.filter-select' ).trigger( 'change' );

						// Make the call
						searchFilter.makeTheCall( searchFilter.$base_url, true );
					}
				}
			);
		},
		/**
		 * Bind all event listeners.
		 *
		 * @since 1.0.0
		 */
		bind: function () {

			$(".page-template-our-people .search-filter").bind(
				// Debounce for 1 second before triggering
				"keyup change", jh_custom.debounce( 
					function() {
				  		searchFilter.makeTheCall(searchFilter.buildTheURL()),
						1000
					}
				)
			);
		},
		/**
		 * Submit Button.
		 *
		 * @since 1.0.0
		 */
		submit: function () {
			$(".page-template-our-people .search-filter").submit(
				function (e) {
					e.preventDefault();
					searchFilter.makeTheCall(searchFilter.buildTheURL());
				});

		},

		/**
		 *  Adjust the filter on initial page load if coming from another link and not ajax
		 *
		 * @since 1.0.0
		 */
		pageInit: function () {

			// If there are any query vars at all, scroll down to the results
			if ($.isEmptyObject(searchFilter.$query_vars)) {
				// No empty actions at this time
			} else {
				// Wait until doc ready to scroll to avoid jitter
				$(document).ready(
					function () {
						$.scrollTo('.page-template-our-people #ajax-archive', 500, { offset: -75 });
					}
				);
			}
		},

	};

	searchFilter.init();

})(window, document, jQuery);
